import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/views/Login"
import MainLayout from "@/views/MainLayout";
import Register from "@/views/Register";
import Dashboard from "@/views/Dashboard"
import ChooseGoods from "@/views/ChooseGoods"
import Goods from "@/views/Goods"
import GoodsPickup from "@/views/GoodsPickup"
import GoodsManage from "@/views/Goods/components/GoodsManage";
import GoodsManagePickup from "@/views/GoodsPickup/components/GoodsManagePickup";
import AddOrUpdateInstall from "@/views/Goods/components/Install/AddOrUpdateInstall.vue";
import AddOrUpdateDelivery from "@/views/Goods/components/Delivery/AddOrUpdateDelivery.vue";
import AddOrUpdateFreight from "@/views/Goods/components/Freight/AddOrUpdateFreight.vue";
import Freight from "@/views/Goods/components/Freight/FreightList.vue";
import Permission from "@/views/Permission";
import GroupManage from "@/views/GroupManage";
import GroupDetail from "@/views/GroupManage/components/GroupDetail/index.vue";
import Finance from "@/views/Finance"
import Demo from "@/views/Demo"
import Order from "@/views/Order"
import store from '@/store';
import eCardNew from '@/views/eCardNew/index.vue'
import Suppliers from '@/views/Suppliers/index.vue'
import VipGoods from "@/views/VipGoods/index.vue";
import VipUser from "@/views/VipUser/index.vue";
import vipCollectiveProcurementOrder from "@/views/vipCollectiveProcurementOrder/index.vue"
import PayCallback from "@/views/PayCallback/index.vue";
import CustomizationShop from "@/views/CustomizationShop/index.vue";
import BannerTopic from "@/views/BannerTopic"
import Destination from "@/views/Travel/Destination/index.vue"
import TravelGroupManage from "@/views/TravelGroupManage";
import GroupDetailTravel from "@/views/TravelGroupManage/components/GroupDetail/index.vue";


import Travel from "@/views/Travel/index.vue";
import SpaceStation from "@/views/SpaceStation/index.vue";
import TravelOrder from "@/views/TravelOrder/index.vue";
import VipOrder from "@/views/VipOrder/index.vue";
import Withdrawal from "@/views/Withdrawal/index.vue";

import Article from "@/views/Article/index.vue";
import WithdrawalApplication from "@/views/withdrawalApplication/index.vue";
import Statistics from "@/views/Statistics/index.vue";
import checkIn from "@/views/CheckIn/index.vue";
import ProductReview from "@/views/ProductReview/index.vue";
import indexGoods from "@/views/indexGoods/index.vue";
import ShopManage from "@/views/ShopManage/index.vue";
import Poster from "@/views/Poster/index.vue";
import BasicConfig from "@/views/basicConfig/documentConfig/index.vue"
import SysMsg from "@/views/SysMsg/index.vue"
import OrderPackage from "@/views/orderPackage/index.vue"
import PackageSystemConfig from "@/views/packageSystemConfig/index.vue"

import SelectionLibrary from "@/views/SelectionLibrary";
import SelectionLibraryDetail from "@/views/SelectionLibrary/components/GroupDetail/index.vue";
import BannerConfig from "@/views/BannerConfig"
import withdrawalApplicationSupply from "@/views/withdrawalApplicationSupply/index.vue";
import PartnerTask from "@/views/PartnerTask/index.vue";




Vue.use(VueRouter)

let permissionRouter = [
    {
        path: '/',
        component: Dashboard,
        title: "首页",
        name: "Dashboard",
        subTitle: "首页",
        icon: "ki-graph-3",
        role: ["user:login"]
    },
    /*{
        path: '/travel',
        component: Travel,
        title: "旅游线路",
        subTitle: "旅游线路",
        icon: "ki-duotone ki-abstract-35",
        role: ["goods:manage:sjGoods:query:list"],
        children: [
            {
                path: '',
                component: Travel,
                title: "旅游管理",
                subTitle: "旅游管理",
                icon: "ki-purchase",
                role: ["goods:manage:sjGoods:query:list"],
            }
        ]
    },*/
/*    {
        path: '/shopManage',
        component: ShopManage,
        title: "店铺管理",
        subTitle: "店铺管理",
        icon: "ki-shop",
        role: ["goods:manage:sjGoods:query:list"],
        children: [
            {
                path: '',
                component: ShopManage,
                title: "店铺管理",
                subTitle: "店铺管理",
                icon: "ki-shop",
                role: ["goods:manage:sjGoods:query:list"],
            }/!*,{
                path: '',
                title: "模板管理",
                component:Goods,
                subTitle: "模板管理",
                icon: "ki-purchase",
                role: ["goods:manage:freight:query:list"],
                children:[
                    {
                        path: 'freight',
                        component: Freight,
                        title: "运费模板",
                        subTitle: "运费模板",
                        icon: "ki-dollar",
                        role: ["goods:manage:freight:query:list"],
                    }, {
                        path: 'delivery',
                        component: Delivery,
                        title: "送货上门",
                        subTitle: "送货上门",
                        icon: "ki-dollar",
                        role: ["goods:manage:install:query:list"],
                    }, {
                        path: 'install',
                        component: Install,
                        title: "上门安装",
                        subTitle: "上门安装",
                        icon: "ki-dollar",
                        role: ["goods:manage:delivery:query:list"],
                    }
                ]
            }*!/
        ]
    },
    {
        path: '/poster',
        component: Poster,
        title: "店铺海报",
        subTitle: "店铺海报",
        icon: "ki-duotone ki-abstract-21",
        role: ["goods:manage:sjGoods:query:list"],
        children: [
            {
                path: '',
                component: Poster,
                title: "店铺海报",
                subTitle: "店铺海报",
                icon: "ki-shop",
                role: ["goods:manage:sjGoods:query:list"],
            }
        ]
    },*/
    {
        path: '/goods',
        component: Goods,
        title: "商品",
        subTitle: "商品",
        icon: "ki-purchase",
        role: ["goods:manage:sjGoods:query:list"],
        children: [
            {
                path: '',
                component: GoodsManage,
                title: "商品管理",
                subTitle: "商品管理",
                icon: "ki-purchase",
                role: ["goods:manage:sjGoods:query:list"],
            }/*,{
                path: '',
                title: "模板管理",
                component:Goods,
                subTitle: "模板管理",
                icon: "ki-purchase",
                role: ["goods:manage:freight:query:list"],
                children:[
                    {
                        path: 'freight',
                        component: Freight,
                        title: "运费模板",
                        subTitle: "运费模板",
                        icon: "ki-dollar",
                        role: ["goods:manage:freight:query:list"],
                    }, {
                        path: 'delivery',
                        component: Delivery,
                        title: "送货上门",
                        subTitle: "送货上门",
                        icon: "ki-dollar",
                        role: ["goods:manage:install:query:list"],
                    }, {
                        path: 'install',
                        component: Install,
                        title: "上门安装",
                        subTitle: "上门安装",
                        icon: "ki-dollar",
                        role: ["goods:manage:delivery:query:list"],
                    }
                ]
            }*/
        ]
    },
/*    {
        path: '/goods-pickup',
        component: GoodsPickup,
        title: "到店服务",
        subTitle: "到店服务",
        icon: "ki-purchase",
        role: ["goods:manage:sjGoods:query:list"],
        children: [
            {
                path: '',
                component: GoodsManagePickup,
                title: "到店服务管理",
                subTitle: "到店服务管理",
                icon: "ki-purchase",
                role: ["goods:manage:sjGoods:query:list"],
            }/!*,{
                path: '',
                title: "模板管理",
                component:Goods,
                subTitle: "模板管理",
                icon: "ki-purchase",
                role: ["goods:manage:freight:query:list"],
                children:[
                    {
                        path: 'freight',
                        component: Freight,
                        title: "运费模板",
                        subTitle: "运费模板",
                        icon: "ki-dollar",
                        role: ["goods:manage:freight:query:list"],
                    }, {
                        path: 'delivery',
                        component: Delivery,
                        title: "送货上门",
                        subTitle: "送货上门",
                        icon: "ki-dollar",
                        role: ["goods:manage:install:query:list"],
                    }, {
                        path: 'install',
                        component: Install,
                        title: "上门安装",
                        subTitle: "上门安装",
                        icon: "ki-dollar",
                        role: ["goods:manage:delivery:query:list"],
                    }
                ]
            }*!/
        ]
    },*/
    {
        path: '/vip',
        component: VipUser,
        title: "会员天地",
        subTitle: "会员天地",
        icon: "ki-duotone ki-badge",
        role: ["association:show"],
        children: [
            {
                path: '',
                component: VipUser,
                title: "会员天地",
                subTitle: "会员天地",
                icon: "ki-duotone ki-badge",
                role: ["association:show"],
            }
        ]
    },
    {
        path: '/vipGoods',
        component: VipGoods,
        title: "商会商品池",
        subTitle: "商会商品池",
        icon: "ki-duotone ki-abstract-21",
        role: ["association:show"],
        children: [
            {
                path: '',
                component: VipGoods,
                title: "商会商品池",
                subTitle: "商会商品池",
                icon: "ki-duotone ki-abstract-21",
                role: ["association:show"],
            }
        ]
    },
    {
        path: '/chooseGoods',
        component: ChooseGoods,
        title: "全国商品池",
        subTitle: "全国商品池",
        icon: "ki-duotone ki-abstract-35",
        role: ["pro:pool:choose:goods:query:list:new"],
        children: [
            {
                path: '',
                component: ChooseGoods,
                title: "全国商品池",
                subTitle: "全国商品池",
                icon: "ki-duotone ki-abstract-35",
                role: ["pro:pool:choose:goods:query:list:new"],
            }
        ]
    },
    // {
    //     path: '/shop',
    //     component: CustomizationShop,
    //     title: "用户管理",
    //     subTitle: "用户管理",
    //     icon: "ki-profile-user",
    //     role: ["finance:order:sj:query:list"],
    //     children: [
    //         {
    //             path: '',
    //             component: CustomizationShop,
    //             title: "用户管理",
    //             subTitle: "用户管理",
    //             icon: "ki-shop",
    //             role: ["finance:order:sj:query:list"],
    //         }
    //     ]
    //
    // },
    // {
    //     path: '/eCard',
    //     component: eCard,
    //     title: "数字卡券",
    //     subTitle: "卡券",
    //     icon: "ki-graph-3",
    //     role: ["user:login"],
    //     children: [
    //         {
    //             path: '',
    //             component: ChooseGoods,
    //             title: "数字卡券",
    //             subTitle: "卡券",
    //             icon: "ki-graph-3",
    //             role: ["user:login"],
    //         }
    //     ]
    //
    // },
    {
        path: '/eCardNew',
        component: eCardNew,
        title: "数字卡券",
        subTitle: "卡券",
        icon: "ki-graph-3",
        role: ["goods:manage:goods:e:card:combo:gift:voucher:list"],
        children: [
            {
                path: '',
                component: eCardNew,
                title: "数字卡券",
                subTitle: "卡券",
                icon: "ki-graph-3",
                role: ["goods:manage:goods:e:card:combo:gift:voucher:list"],
            }
        ]

    },
  /*  {
        path: '/travelOrder',
        component: TravelOrder,
        title: "线路订单",
        subTitle: "线路订单",
        icon: "ki-delivery-3",
        role: ["finance:order:sj:query:list"],
        children: [
            {
                path: '',
                component: TravelOrder,
                name: "Order",
                title: "线路订单",
                subTitle: "线路订单",
                icon: "ki-delivery-3",
                role: ["finance:order:sj:query:list"],
            }
        ]
    },*/
    {
        path: '/product-review',
        component: ProductReview,
        title: "商品审核",
        subTitle: "商品审核",
        icon: "el-icon-folder-opened",
        role: ["admin.ProductReview"],
        children: [
            {
                path: '',
                component: ProductReview,
                name: "product-review",
                title: "商品审核",
                subTitle: "商品审核",
                icon: "el-icon-folder-opened",
                role: ["admin.ProductReview"],
            }
        ]
    },
    {
        path: '/order',
        component: Order,
        title: "订单",
        subTitle: "订单",
        icon: "ki-delivery-3",
        role: ["finance:order:sj:query:list"],
        children: [
            {
                path: '',
                component: Order,
                name: "Order",
                title: "订单",
                subTitle: "订单",
                icon: "ki-delivery-3",
                role: ["finance:order:sj:query:list"],
            }
        ]
    },

   /* {
        path: '/vipOrder',
        component: VipOrder,
        title: "会员结算订单",
        subTitle: "会员结算订单",
        icon: "ki-delivery-3",
        role: ["finance:order:sj:query:list"],
        children: [
            {
                path: '',
                component: VipOrder,
                name: "Order",
                title: "会员结算订单",
                subTitle: "会员结算订单",
                icon: "ki-delivery-3",
                role: ["finance:order:sj:query:list"],
            }
        ]
    },*/
    /*{
        path: '/withdrawal',
        component: Withdrawal,
        title: "提现",
        subTitle: "提现",
        icon: "ki-delivery-3",
        role: ["finance:order:sj:query:list"],
        children: [
            {
                path: '',
                component: Withdrawal,
                name: "Withdrawal",
                title: "提现",
                subTitle: "提现",
                icon: "ki-delivery-3",
                role: ["finance:order:sj:query:list"],
            }
        ]
    },*/
   /* {
        path: '/destination',
        component: Destination,
        title: "精选目的地管理",
        subTitle: "精选目的地管理",
        icon: "ki-graph-3",
        role: ["finance:order:sj:query:list"],
        children: [
            {
                path: '',
                component: Destination,
                name: "Destination",
                title: "精选目的地管理",
                subTitle: "精选目的地管理",
                icon: "ki-graph-3",
                role: ["finance:order:sj:query:list"],
            }
        ]
    },*/
   /* {
        path: '/bannerTopic',
        component: BannerTopic,
        title: "轮播/活动",
        subTitle: "轮播/活动",
        icon: "ki-graph-3",
        role: ["finance:order:sj:query:list"],
        children: [
            {
                path: '',
                component: BannerTopic,
                name: "BannerTopic",
                title: "轮播/活动",
                subTitle: "轮播/活动",
                icon: "ki-graph-3",
                role: ["finance:order:sj:query:list"],
            }
        ]
    },*/
    // {
    //     path: '/spaceStation',
    //     component: SpaceStation,
    //     title: "千城万店",
    //     subTitle: "千城万店",
    //     icon: "ki-graph-3",
    //     role: ["finance:order:sj:query:list"],
    //     children: [
    //         {
    //             path: '',
    //             component: SpaceStation,
    //             name: "SpaceStation",
    //             title: "千城万店",
    //             subTitle: "千城万店",
    //             icon: "ki-graph-3",
    //             role: ["finance:order:sj:query:list"],
    //         }
    //     ]
    // },
    // {
    //     path: '/article',
    //     component: Article,
    //     title: "商学院",
    //     subTitle: "商学院",
    //     icon: "ki-shop",
    //     role: ["finance:order:sj:query:list"],
    //     children: [
    //         {
    //             path: '',
    //             component: Article,
    //             name: "Article",
    //             title: "商学院",
    //             subTitle: "商学院",
    //             icon: "ki-graph-3",
    //             role: ["finance:order:sj:query:list"],
    //         }
    //     ]
    // },
    {
        path: '/user',
        component: CustomizationShop,
        title: "用户管理",
        subTitle: "用户管理",
        icon: "ki-shop",
        role: ["admin.user.list"],
        children: [
            {
                path: '',
                component: CustomizationShop,
                title: "用户管理",
                subTitle: "用户管理",
                icon: "ki-shop",
                role: ["admin.user.list"],
            }
        ]

    },
    {
        path: '/withdrawalApplicationSupply',
        component: withdrawalApplicationSupply,
        title: "供应链提现",
        subTitle: "供应链提现",
        icon: "el-icon-money",
        role: ["new:supply:withdrawal"],
        children: [
            {
                path: '',
                component: withdrawalApplicationSupply,
                name: "withdrawalApplicationSupply",
                title: "供应链提现",
                subTitle: "供应链提现",
                icon: "el-icon-money",
                role: ["new:supply:withdrawal"],
            }
        ]
    },
     {
         path: '/withdrawalApplication',
         component: WithdrawalApplication,
         title: "提现",
         subTitle: "提现",
         icon: "el-icon-money",
         role: ["admin.withdrawal"],
         children: [
             {
                 path: '',
                 component: WithdrawalApplication,
                 name: "withdrawalApplication",
                 title: "提现",
                 subTitle: "提现",
                 icon: "el-icon-money",
                 role: ["admin.withdrawal"],
             }
         ]
     },
    // {
    //     path: '/check-in',
    //     component: checkIn,
    //     title: "商家入驻",
    //     subTitle: "商家入驻",
    //     icon: "el-icon-office-building",
    //     role: ["admin.checkin"],
    //     children: [
    //         {
    //             path: '',
    //             component: checkIn,
    //             name: "check-in",
    //             title: "商家入驻",
    //             subTitle: "商家入驻",
    //             icon: "el-icon-office-building",
    //             role: ["admin.checkin"],
    //         }
    //     ]
    // },
    // {
    //     path: '/statistics',
    //     component: Statistics,
    //     title: "统计",
    //     subTitle: "统计",
    //     icon: "el-icon-s-data",
    //     role: ["finance:order:sj:query:list"],
    //     children: [
    //         {
    //             path: '',
    //             component: Statistics,
    //             name: "Article",
    //             title: "统计",
    //             subTitle: "统计",
    //             icon: "ki-graph-3",
    //             role: ["finance:order:sj:query:list"],
    //         }
    //     ]
    // },
    {
        path: '/vipCollectiveProcurementOrder',
        component: vipCollectiveProcurementOrder,
        title: "集采订单",
        subTitle: "集采订单",
        icon: "ki-delivery-3",
        role: ["vip:collective:procurement:list"],
        children: [
            {
                path: '',
                component: vipCollectiveProcurementOrder,
                name: "vipCollectiveProcurementOrder",
                title: "集采订单",
                subTitle: "集采订单",
                icon: "ki-delivery-3",
                role: ["vip:collective:procurement:list"],
            }
        ]
    },
    {
        path: '/finance',
        component: Finance,
        title: "财务",
        subTitle: "财务",
        icon: "ki-tag",
        role: ["finance:order:sj:query:my:cashOut"],
        redirct: "",
        children: [
            {
                path: '',
                component: Finance,
                title: "财务管理",
                subTitle: "财务管理",
                icon: "ki-tag",
                role: ["finance:order:sj:query:my:cashOut"],
            }
        ]
    },
    {
        path: '/Suppliers',
        component: Suppliers,
        title: "供应商",
        subTitle: "供应商",
        icon: "ki-profile-user",
        role: ["user:permission:create:distributor"],
        redirct: "",
        children: [
            {
                path: '',
                component: Permission,
                title: "供应商管理",
                subTitle: "供应商管理",
                icon: "ki-tag",
                role: ["user:permission:create:distributor"],
            }
        ]
    },
    {
        path: '/basicConfig',
        component: BasicConfig,
        title: "平台配置",
        subTitle: "平台配置",
        icon: "ki-profile-user",
        role: ["user:permission:update"],
        redirct: "",
        children: [
            {
                path: '',
                component: BasicConfig,
                title: "平台配置",
                subTitle: "平台配置",
                icon: "ki-tag",
                role: ["user:permission:update"],
            }
        ]
    },
    {
        path: '/sysMsg',
        component: SysMsg,
        title: "系统消息",
        subTitle: "系统消息",
        icon: "ki-profile-user",
        role: ["user:permission:update"],
        redirct: "",
        children: [
            {
                path: '',
                component: SysMsg,
                title: "系统消息",
                subTitle: "系统消息",
                icon: "ki-tag",
                role: ["user:permission:update"],
            }
        ]
    },
    {
        path: '/partnerTask',
        component: PartnerTask,
        title: "合伙人任务",
        subTitle: "合伙人任务",
        icon: "ki-profile-user",
        role: ["user:permission:update"],
        redirct: "",
        children: [
            {
                path: '',
                component: PartnerTask,
                title: "合伙人任务",
                subTitle: "合伙人任务",
                icon: "ki-tag",
                role: ["user:permission:update"],
            }
        ]
    },
    {
        path: '/orderPackage',
        component: OrderPackage,
        title: "算力订单",
        subTitle: "算力订单",
        icon: "ki-profile-user",
        role: ["user:permission:update"],
        redirct: "",
        children: [
            {
                path: '',
                component: OrderPackage,
                title: "算力订单",
                subTitle: "算力订单",
                icon: "ki-tag",
                role: ["user:permission:update"],
            }
        ]
    },
   /* {
        path: '/packageSystemConfig',
        component: PackageSystemConfig,
        title: "算力运营配置",
        subTitle: "算力运营配置",
        icon: "el-icon-cpu",
        role: ["user:permission:update"],
        redirct: "",
        children: [
            {
                path: '',
                component: PackageSystemConfig,
                title: "算力运营配置",
                subTitle: "算力运营配置",
                icon: "el-icon-cpu",
                role: ["user:permission:update"],
            }
        ]
    },*/
/*    {
        path: '/indexGoods',
        component: indexGoods,
        title: "首页商品管理",
        subTitle: "首页商品管理",
        icon: "ki-profile-user",
        role: ["admin.index.goods"],
        redirct: "",
        children: [
            {
                path: '',
                component: indexGoods,
                title: "首页商品管理",
                subTitle: "首页商品管理",
                icon: "ki-tag",
                role: ["admin.index.goods"],
            }
        ]
    },*/
    {
        path: '/permission',
        component: Permission,
        title: "用户权限",
        subTitle: "用户权限",
        icon: "ki-user",
        role: ["user:permission:update"],
        redirct: "",
        children: [
            {
                path: '',
                component: Permission,
                title: "用户权限管理",
                subTitle: "用户权限管理",
                icon: "ki-tag",
                role: ["user:permission:update"],
            }
        ]
    },
    {
        path: '/selectionLibrary',
        component: SelectionLibrary,
        title: "选品库",
        subTitle: "选品库",
        icon: "ki-user",
        role: ["new:sel:edit"],
        redirct: "",
        children: [
            {
                path: '',
                component: SelectionLibrary,
                title: "选品库管理",
                subTitle: "选品库管理",
                icon: "ki-tag",
                role: ["new:sel:edit"],
            }
        ]
    },
    {
        path: '/bannerConfig',
        component: BannerConfig,
        title: "广告位",
        subTitle: "广告位",
        icon: "ki-graph-3",
        role: ["new:banner"],
        children: [
            {
                path: '',
                component: BannerConfig,
                name: "BannerConfig",
                title: "广告位",
                subTitle: "广告位",
                icon: "ki-graph-3",
                role: ["new:banner"],
            }
        ]
    },
]
store.state.permission.routes = permissionRouter

const routes = [
    {
        path: '/',
        component: MainLayout,
        children: [
            ...permissionRouter
        ]
    },
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/demo',
        component: Demo,
    },
    {
        path: '/payCallback',
        component: PayCallback,
    },
    // {
    //     // path: '/register',
    //     component: Register,
    // }
    // ,
    {
        path: '/register',
        component: Register,
    }
    // , {
    //     path: '/goods',
    //     component: MainLayout,
    //     title: "商品",
    //     subTitle: "商品",
    //     icon: "ki-purchase",
    //     role: ["user:login"],
    //     children: [
    //         {
    //             path: 'freight',
    //             component: Freight,
    //             title: "运费模板",
    //             subTitle: "运费模板",
    //             icon: "ki-dollar",
    //             role: ["user:login"],
    //         }, {
    //             path: 'delivery',
    //             component: Delivery,
    //             title: "送货上门",
    //             subTitle: "提现管理",
    //             icon: "ki-dollar",
    //             role: ["user:login"],
    //         }, {
    //             path: 'install',
    //             component: Install,
    //             title: "上门安装",
    //             subTitle: "上门安装",
    //             icon: "ki-dollar",
    //             role: ["user:login"],
    //         }
    //     ]
    // }
    ,
    // {
    //     path: '/goodsManage',
    //     component: MainLayout,
    //     children: [
    //         {
    //             path: 'addOrUpdateGoods/:id/:status?',
    //             component: AddOrUpdateVisible,
    //             name: "AddOrUpdateVisible",
    //             title: "商品管理",
    //             subTitle: "商品管理",
    //             icon: "ki-purchase",
    //             role: ["user:login"],
    //         }
    //     ]
    // },
    {
        path: '/install',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateInstall/:id?',
                component: AddOrUpdateInstall,
                name: "AddOrUpdateInstall",
                title: "上门安装模板",
                subTitle: "上门安装模板",
                icon: "ki-dollar",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/goods',
        component: MainLayout,
        role: ["user:login"],
        children: [
            {
                path: 'goods_group',
                component: GroupManage,
                name: "GroupManage",
                title: "分组管理",
                subTitle: "分组管理",
                role: ["user:login"],
            },
            {
                path: 'groupDetail/:id?',
                component: GroupDetail,
                name: "GroupDetail",
                title: "分组详情",
                subTitle: "分组管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/delivery',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateDelivery/:id?',
                component: AddOrUpdateDelivery,
                name: "AddOrUpdateDelivery",
                title: "送货上门模板",
                subTitle: "送货上门模板",
                icon: "ki-dollar",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/freight',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateFreight/:id?',
                component: AddOrUpdateFreight,
                name: "AddOrUpdateFreight",
                title: "运费模板",
                subTitle: "运费模板",
                icon: "ki-dollar",
                role: ["user:login"],
            }
        ]
    },

    {
        path: '/',
        component: MainLayout,
        children: [
            ...permissionRouter
        ]
    },
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/register',
        component: Register,
    },
    {
        path: '/goodsManage',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateGoods/:id?',
                component: () => import("@/views/Goods/components/GoodsManage/components/AddOrUpdateVisible/AddOrUpdateGoods.vue"),
                name: "AddOrUpdateVisible",
                title: "商品管理",
                subTitle: "商品管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/goodsManagePickup',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateGoods/:id?',
                component: () => import("@/views/GoodsPickup/components/GoodsManagePickup/components/AddOrUpdateVisible/AddOrUpdateGoods.vue"),
                name: "AddOrUpdateVisiblePickup",
                title: "商品管理",
                subTitle: "商品管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/messages',
        component: MainLayout,
        children: [
            {
                path: '',
                component: () => import("@/views/AllMessages"),
                name: "AllMessages",
                title: "消息管理",
                subTitle: "消息管理",
            }
        ]
    },
    // {
    //     path: '/comboGiftPack',
    //     component: MainLayout,
    //     role: ["user:login"],
    //     children: [
    //         {
    //             path: '',
    //             component: () => import("@/views/ComboGiftPack"),
    //             name: "comboGiftPack",
    //             title: "组合礼包",
    //             subTitle: "组合礼包",
    //             role: ["user:login"],
    //         }
    //     ]
    // },
     {
         path: '/comboGiftPack',
         component: MainLayout,
         children: [
             {
                 path: 'addOrUpdateComboGiftPack/:id?',
                 component: () => import("@/views/ComboGiftPack/components/AddComboGiftPack/index.vue"),
                 name: "AddOrUpdateComboGiftPack",
                 title: "组合礼包",
                 //subTitle: "组合礼包",
                 icon: "ki-purchase",
                 role: ["user:login"],
             }
         ]
     },
    {
        path: '/travelManage',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateTravel/:id?',
                component: () => import("@/views/Travel/TravelManage/AddOrUpdate/AddOrUpdateTravel.vue"),
                name: "AddOrUpdateTravel",
                title: "旅游线路管理",
                subTitle: "旅游线路管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/travel',
        component: MainLayout,
        role: ["user:login"],
        children: [
            {
                path: 'travel_group',
                component: TravelGroupManage,
                name: "TravelGroupManage",
                title: "分组管理",
                subTitle: "分组管理",
                role: ["user:login"],
            },
            {
                path: 'groupDetailTravel/:id?',
                component: GroupDetailTravel,
                name: "GroupDetailTravel",
                title: "分组详情",
                subTitle: "分组管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/spaceStation',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateSpaceStation/:id?',
                component: () => import("@/views/SpaceStation/AddOrUpdateSpaceStation.vue"),
                name: "AddOrUpdateSpaceStation",
                title: "空间站",
                subTitle: "空间站",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/articleManage',
        component: MainLayout,
        children: [
            {
                path: 'addOrUpdateArticle/:id?',
                component: () => import("@/views/Article/ArticleManage/AddOrUpdate/AddOrUpdateArticle.vue"),
                name: "AddOrUpdateArticle",
                title: "文章管理",
                subTitle: "文章管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/article',
        component: MainLayout,
        role: ["user:login"],
        children: [
            {
                path: 'goods_group',
                component: GroupManage,
                name: "GroupManage",
                title: "分组管理",
                subTitle: "分组管理",
                role: ["user:login"],
            },
            {
                path: 'groupDetail/:id?',
                component: GroupDetail,
                name: "GroupDetail",
                title: "分组详情",
                subTitle: "分组管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },

    {
        path: '/freight',
        component: MainLayout,
        role: ["user:login"],
        children: [
            {
                path: 'freight',
                component: () => import("@/views/Goods/components/Freight/FreightList.vue"),
                name: "Freight",
                title: "运费管理",
                subTitle: "运费管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
    {
        path: '/selectionLibrary',
        component: MainLayout,
        role: ["user:login"],
        children: [
            {
                path: 'selectionLibraryDetail/:id?',
                component: SelectionLibraryDetail,
                name: "SelectionLibraryDetail",
                title: "选品库商品管理",
                subTitle: "选品库商品管理",
                icon: "ki-purchase",
                role: ["user:login"],
            }
        ]
    },
]
console.log(routes)
store.state.permission.tempRoutes = routes
const router = new VueRouter({
    // mode: 'history',
    routes
})

export default router
